import styled from "styled-components";

export const IPContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  justify-content: center;
  align-items: center;
  animation: fade-in 0.3s forwards;

  @keyframes bounce-in {
    from {
      transform: translateY(50px);
      width: 470px;
    }
  }
`;

export const IPCenter = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const IPAlign = styled.div`
  display: flex;
  flex-direction: column;
`;

export const IPExitButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  align-self: flex-end;
  margin-bottom: 10px;
  border-radius: 50%;
  border: 2px solid white;
  transition: 0.2s;

  &:hover {
    border: 2px solid var(--color-vermelho-mrpay);
  }
`;

export const IPBox = styled.div`
  background-color: white;
  box-shadow: 4px 3px 10px black;
  width: 500px;
  border-radius: 10px;
  padding: 15px;
  text-align: center;
  animation: bounce-in 0.4s forwards;
  height: fit-content;

  h2 {
    padding-bottom: 5px;
    color: var(--color-azul-mrpay);
  }

  @media screen and (min-width: 451px) {
    width: 410px;

    h2 {
      font-size: 24px;
    }

    p {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 450px) {
    width: 285px;

    h2 {
      font-size: 21px;
      padding-top: 5px;
    }

    p {
      font-size: 14px;
    }
  }

  /* @media screen and (min-width: 250px) and (max-width: 300px) {
    width: 200px;
    height: 140px;

    h2 {
      font-size: 16px;
    }

    p {
      font-size: 14px;
    }
  } */
`;
